module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 41);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return uuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return extractBlobContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return extractFormData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decodeQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return transformToFormData; });
/* unused harmony export isValueObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return resolveHeaders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isBrowser; });
/* unused harmony export isReactNative */
/* unused harmony export isNodeJS */
/* unused harmony export isPromise */
/* harmony import */ var _enums_ContentTypeEnum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var hasOwnProp = Object.prototype.hasOwnProperty;
function get(obj, path) {
    if (path != null) {
        var keys = Array.isArray(path) ? path : path.split('.');
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (!obj || !hasOwnProp.call(obj, key)) {
                obj = undefined;
                break;
            }
            obj = obj[key];
        }
        return obj;
    }
    return void 0;
}
function set(obj, path, value) {
    var keys = Array.isArray(path) ? path : path.split('.');
    var i;
    for (i = 0; i < keys.length - 1; i++) {
        var key = keys[i];
        if (!hasOwnProp.call(obj, key))
            obj[key] = {};
        obj = obj[key];
    }
    obj[keys[i]] = value;
    return value;
}
function uuid() {
    // Public Domain/MIT
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
}
// from lodash
var toString = Object.prototype.toString;
function getTag(value) {
    if (value == null) {
        return value === undefined ? '[object Undefined]' : '[object Null]';
    }
    return toString.call(value);
}
function isString(value) {
    var type = typeof value;
    return (type === 'string' ||
        (type === 'object' &&
            value != null &&
            !Array.isArray(value) &&
            getTag(value) == '[object String]'));
}
function isObject(value) {
    var type = typeof value;
    return value != null && (type === 'object' || type === 'function');
}
function isFunction(value) {
    return typeof value === 'function';
}
function extractBlobContent(blob) {
    return new Promise(function (res, rej) {
        var reader = new FileReader();
        reader.addEventListener('loadend', function () {
            res(reader.result);
        });
        reader.addEventListener('error', function () {
            rej(reader.error);
        });
        reader.readAsArrayBuffer(blob);
    });
}
function extractFormData(formData) {
    return Object.values(formData).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return Object.assign(acc, (_b = {}, _b[key] = value, _b));
    }, {});
}
function decodeQueryString(params, mode) {
    if (params === void 0) { params = {}; }
    return Object.keys(params)
        .map(function (k) {
        var value = params[k];
        if (Array.isArray(value)) {
            switch (mode) {
                case 'array':
                    return value
                        .map(function (val) { return encodeURIComponent(k) + "[]=" + encodeURIComponent(val); })
                        .join('&');
                case 'comma':
                default:
                    return encodeURIComponent(k) + "=" + value.join(',');
            }
        }
        else if (value !== null && value !== undefined) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(value);
        }
    })
        .filter(Boolean)
        .join('&');
}
function transformToFormData(body, form, namespace) {
    var formData = form || new FormData();
    for (var property in body) {
        var value = body[property];
        if (!body.hasOwnProperty(property) || !value) {
            continue;
        }
        var formKey = namespace
            ? Array.isArray(body)
                ? namespace + "[]"
                : namespace + "[" + property + "]"
            : property;
        if (value instanceof Date) {
            formData.append(formKey, value.toISOString());
        }
        else if (isValueObject(value)) {
            transformToFormData(value, formData, formKey);
        }
        else {
            formData.append(formKey, value);
        }
    }
    return formData;
}
function isValueObject(value) {
    if (isReactNative()) {
        return typeof value === 'object';
    }
    else {
        return typeof value === 'object' && !(value instanceof File);
    }
}
function resolveHeaders(options) {
    var additionalHeaders = {};
    if (options.contentType === _enums_ContentTypeEnum__WEBPACK_IMPORTED_MODULE_0__[/* ContentTypeEnum */ "a"].JSON) {
        additionalHeaders['Content-Type'] = 'application/json';
    }
    else if (options.contentType === _enums_ContentTypeEnum__WEBPACK_IMPORTED_MODULE_0__[/* ContentTypeEnum */ "a"].FORM_DATA) {
        additionalHeaders['Content-Type'] = 'multipart/form-data';
    }
    if (options.responseType === 'json') {
        additionalHeaders['Accept'] = 'application/json';
    }
    return __assign(__assign({}, options.headers), additionalHeaders);
}
function isBrowser() {
    return typeof document != 'undefined';
}
function isReactNative() {
    return typeof document == 'undefined' && typeof navigator != 'undefined' && navigator.product == 'ReactNative';
}
function isNodeJS() {
    return !isBrowser() && !isReactNative();
}
function isPromise(promise) {
    return !!promise && typeof promise.then === 'function';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(17);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentTypeEnum; });
// todo use mime-types, mime-db packages
var ContentTypeEnum;
(function (ContentTypeEnum) {
    ContentTypeEnum["JSON"] = "json";
    ContentTypeEnum["FORM_DATA"] = "form-data";
})(ContentTypeEnum || (ContentTypeEnum = {}));


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _helpers__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _helpers__WEBPACK_IMPORTED_MODULE_0__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _helpers__WEBPACK_IMPORTED_MODULE_0__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _helpers__WEBPACK_IMPORTED_MODULE_0__["k"]; });




/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseResource; });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);

var BaseResource = /** @class */ (function () {
    function BaseResource(urlSource) {
        this.urlSource = urlSource;
        this.errorHandlers = [];
    }
    BaseResource.prototype.getBaseUrl = function () {
        var _this = this;
        if (Object(_utils__WEBPACK_IMPORTED_MODULE_0__[/* isFunction */ "c"])(this.urlSource)) {
            return this.urlSource();
        }
        else if (typeof this.urlSource === 'string') {
            return new Promise(function (resolve) { return resolve(_this.urlSource); });
        }
        else {
            throw new Error('BaseResource#resolveBaseUrl(): urlSource must be string or Promise<string>');
        }
    };
    BaseResource.prototype.setUrlSource = function (urlSource) {
        this.urlSource = urlSource;
    };
    BaseResource.prototype.addErrorHandler = function (handler) {
        var _this = this;
        this.errorHandlers.push(handler);
        return function () {
            var handlerIndex = _this.errorHandlers.findIndex(function (h) { return h === handler; });
            if (handlerIndex > -1) {
                _this.errorHandlers.splice(handlerIndex, 1);
            }
        };
    };
    BaseResource.prototype.notifyErrorHandlers = function (payload) {
        var _a, _b;
        if ((_a = this.errorHandlers) === null || _a === void 0 ? void 0 : _a.length) {
            for (var i = 0; i < ((_b = this.errorHandlers) === null || _b === void 0 ? void 0 : _b.length); i++) {
                this.errorHandlers[i](payload);
            }
        }
    };
    return BaseResource;
}());



/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(42);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseMapType; });
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);

var BaseMapType = /** @class */ (function () {
    function BaseMapType() {
    }
    BaseMapType.arrayOf = function (mappingStrategy) {
        return BaseMapType.decorateWithAsAttrMap({
            encode: function (values) {
                if (values && values.length && mappingStrategy) {
                    return values.map(function (value) {
                        if (mappingStrategy && mappingStrategy.hasOwnProperty('encode')) {
                            return mappingStrategy.encode(value);
                        }
                        if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isObject */ "g"])(value)) {
                            return BaseMapType.map(value, mappingStrategy);
                        }
                        return null;
                    });
                }
                if (values == null) {
                    return values;
                }
                return [values];
            },
            decode: function (values) {
                if (values && values.length && mappingStrategy) {
                    return values.map(function (value) {
                        if (mappingStrategy && mappingStrategy.hasOwnProperty('encode')) {
                            return mappingStrategy.encode(value);
                        }
                        if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isObject */ "g"])(value)) {
                            return BaseMapType.reverseMap(value, mappingStrategy);
                        }
                        return null;
                    });
                }
                if (values == null) {
                    return values;
                }
                return [values];
            }
        });
    };
    BaseMapType.shapeOf = function (mappingStrategy) {
        return BaseMapType.decorateWithAsAttrMap({
            encode: function (value) { return value && mappingStrategy
                ? BaseMapType.map(value, mappingStrategy)
                : value; },
            decode: function (value) { return value && mappingStrategy
                ? BaseMapType.reverseMap(value, mappingStrategy)
                : value; }
        });
    };
    BaseMapType.decodeEntityKey = function (key) {
        if (key === void 0) { key = 'id'; }
        return function (mappingStrategy) {
            return BaseMapType.decorateWithAsAttrMap({
                encode: function (value) { return value && mappingStrategy
                    ? BaseMapType.map(value, mappingStrategy)
                    : value; },
                decode: function (value) { return value != null
                    ? value[key]
                    : value; }
            });
        };
    };
    BaseMapType.encodeEntityKey = function (key) {
        if (key === void 0) { key = 'id'; }
        return function (mappingStrategy) {
            return BaseMapType.decorateWithAsAttrMap({
                encode: function (value) { return value != null
                    ? value[key]
                    : value; },
                decode: function (value) { return value && mappingStrategy
                    ? BaseMapType.reverseMap(value, mappingStrategy)
                    : value; }
            });
        };
    };
    BaseMapType.encode = function (source, mappingStrategy) {
        return BaseMapType.map(source, mappingStrategy);
    };
    BaseMapType.decode = function (source, mappingStrategy) {
        return BaseMapType.reverseMap(source, mappingStrategy);
    };
    BaseMapType.resolveDecodedValuePath = function (attrMapConfig, resultAttributePath) {
        if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isString */ "h"])(attrMapConfig)) {
            return attrMapConfig;
        }
        if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isObject */ "g"])(attrMapConfig) && Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isString */ "h"])(attrMapConfig.map)) {
            return attrMapConfig.map;
        }
        return resultAttributePath;
    };
    BaseMapType.resolveIsNullable = function (attrMapConfig) {
        if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isObject */ "g"])(attrMapConfig)) {
            return Boolean(attrMapConfig.nullable);
        }
        return false;
    };
    BaseMapType.encodeAttribute = function (decodedObject, attrMapConfig, decodedAttributePath, result) {
        var decodedValue = Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* get */ "d"])(decodedObject, decodedAttributePath);
        if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isFunction */ "f"])(attrMapConfig.encode)) {
            return attrMapConfig.encode(decodedValue, decodedObject, result);
        }
        return decodedValue;
    };
    BaseMapType.decodeAttribute = function (encodedObject, attrMapConfig, encodedAttributePath, result) {
        var encodedValue = encodedObject[encodedAttributePath];
        if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isFunction */ "f"])(attrMapConfig.decode)) {
            return attrMapConfig.decode(encodedValue, encodedObject, result);
        }
        return encodedValue;
    };
    BaseMapType.reverseMap = function (encodedObject, strategy) {
        var strategyKeys = Object.keys(strategy);
        var strategyKeysCount = strategyKeys.length;
        var result = {};
        while (strategyKeysCount--) {
            var encodedAttributePath = strategyKeys[strategyKeysCount];
            var attrMapConfig = strategy[encodedAttributePath];
            var decodedAttributePath = BaseMapType.resolveDecodedValuePath(attrMapConfig, encodedAttributePath);
            var isNullable = BaseMapType.resolveIsNullable(attrMapConfig);
            if (decodedAttributePath) {
                var decodedValue = BaseMapType.decodeAttribute(encodedObject, attrMapConfig, encodedAttributePath, result);
                if (decodedValue != null || isNullable) {
                    Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* set */ "j"])(result, decodedAttributePath, decodedValue);
                }
            }
        }
        return result;
    };
    BaseMapType.map = function (decodedObject, strategy) {
        var strategyKeys = Object.keys(strategy);
        var strategyKeysCount = strategyKeys.length;
        var result = {};
        while (strategyKeysCount--) {
            var resultAttributePath = strategyKeys[strategyKeysCount];
            var attrMapConfig = strategy[resultAttributePath];
            var decodedAttributePath = BaseMapType.resolveDecodedValuePath(attrMapConfig, resultAttributePath);
            var isNullable = BaseMapType.resolveIsNullable(attrMapConfig);
            if (resultAttributePath) {
                var encodedValue = BaseMapType.encodeAttribute(decodedObject, attrMapConfig, decodedAttributePath, result);
                if (encodedValue != null || isNullable) {
                    Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* set */ "j"])(result, resultAttributePath, encodedValue);
                }
            }
        }
        return result;
    };
    BaseMapType.decorateWithAsAttrMap = function (dataMapper) {
        dataMapper.asAttrMap = function (decodeKey) {
            return {
                map: decodeKey,
                encode: function (value) { return dataMapper.encode(value); },
                decode: function (value) { return dataMapper.decode(value); }
            };
        };
        return dataMapper;
    };
    BaseMapType.number = BaseMapType.decorateWithAsAttrMap({
        encode: function (value) {
            if (value != null) {
                if (typeof value === 'string' || typeof value === 'number') {
                    return Number(value);
                }
                return Number.NaN;
            }
            return value;
        },
        decode: function (value) {
            if (value != null) {
                if (typeof value === 'string' || typeof value === 'number') {
                    return Number(value);
                }
                return null;
            }
            return value;
        },
    });
    BaseMapType.string = BaseMapType.decorateWithAsAttrMap({
        encode: function (value) {
            if (value != null) {
                if (value instanceof Date) {
                    return value.toISOString();
                }
                if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isObject */ "g"])(value) || Array.isArray(value)) {
                    return JSON.stringify(value);
                }
                return String(value);
            }
            return value;
        },
        decode: function (value) {
            if (value != null) {
                if (value instanceof Date) {
                    return value.toISOString();
                }
                if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isObject */ "g"])(value) || Array.isArray(value)) {
                    return JSON.stringify(value);
                }
                return String(value);
            }
            return value;
        },
    });
    BaseMapType.bool = BaseMapType.decorateWithAsAttrMap({
        encode: function (value) {
            if (value != null) {
                if (value === 'true')
                    return true;
                if (value === 'false')
                    return false;
                return Boolean(value);
            }
            return value;
        },
        decode: function (value) {
            if (value != null) {
                if (value === 'true')
                    return true;
                if (value === 'false')
                    return false;
                return Boolean(value);
            }
            return value;
        }
    });
    BaseMapType.dateTime = BaseMapType.decorateWithAsAttrMap({
        encode: function (value) {
            if (value instanceof Date) {
                return value.toISOString();
            }
            if (typeof value === 'boolean' || Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isObject */ "g"])(value)) {
                return null;
            }
            if (value != null) {
                return new Date(value).toISOString();
            }
            return value;
        },
        decode: function (value) {
            if (value instanceof Date) {
                return value.toISOString();
            }
            if (typeof value === 'boolean' || Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isObject */ "g"])(value)) {
                return null;
            }
            if (value != null) {
                return new Date(value).toISOString();
            }
            return value;
        }
    });
    return BaseMapType;
}());



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultRepositorySettings; });
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var DefaultRepositorySettings = {
    extractResponseData: function (response) {
        return typeof response === 'object' ? response.data : null;
    },
    extractResponseMeta: function (response) {
        return typeof response === 'object' ? response.meta : null;
    },
    decodeSearchParams: function (params) {
        var page = params.page, per_page = params.per_page, sort = params.sort, response = params.response, search = __rest(params, ["page", "per_page", "sort", "response"]);
        return {
            search: search,
            page: page,
            per_page: per_page,
            order: sort,
            response: response,
        };
    }
};


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultFetchResourceOptions; });
/* harmony import */ var _enums_ContentTypeEnum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var DefaultFetchResourceOptions = {
    headers: {},
    trailingSlash: true,
    responseType: 'json',
    contentType: _enums_ContentTypeEnum__WEBPACK_IMPORTED_MODULE_0__[/* ContentTypeEnum */ "a"].JSON,
    accessType: 'json',
    mode: 'same-origin',
    cache: 'default',
    credentials: 'same-origin',
    redirect: 'follow',
    referrer: 'client',
    timeOffset: true,
    queryParamsDecodeMode: 'comma',
};


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultAxiosResourceOptions; });
var DefaultAxiosResourceOptions = {
    responseType: 'json',
    trailingSlash: true,
    timeOffset: true,
    queryParamsDecodeMode: 'comma',
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(48);
var enhanceError = __webpack_require__(19);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(20);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(20);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(47)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseRepository; });
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _DefaultRepositorySettings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var BaseRepository = /** @class */ (function () {
    function BaseRepository(restResource, dataMapper) {
        this.restResource = restResource;
        this.dataMapper = dataMapper;
        this.requestEntityWrap = function (decodedData) { return decodedData; };
        this.entityIdKey = 'id';
        this.settings = _DefaultRepositorySettings__WEBPACK_IMPORTED_MODULE_1__[/* DefaultRepositorySettings */ "a"];
    }
    BaseRepository.prototype.save = function (entity) {
        return this[this.isEntityNew(entity) ? 'create' : 'update'](entity);
    };
    BaseRepository.prototype.create = function (entity) {
        var _this = this;
        var entityData = this.prepareEntityForRequest(entity);
        var query = this.createQuery(entityData);
        return this.resource()
            .create(query)
            .then(function (res) { return _this.processResponse(res); });
    };
    BaseRepository.prototype.update = function (entity) {
        var _this = this;
        if (this.isEntityNew(entity)) {
            throw new Error('BaseRepository#update(): you can not update a new entity');
        }
        var entityData = this.prepareEntityForRequest(entity);
        var query = this.createQuery(entityData);
        return this.resource(entity)
            .update(query)
            .then(function (res) { return _this.processResponse(res); });
    };
    BaseRepository.prototype.patch = function (entity) {
        var _this = this;
        if (this.isEntityNew(entity)) {
            throw new Error('BaseRepository#update(): you can not patch a new entity');
        }
        var entityData = this.prepareEntityForRequest(entity);
        var query = this.createQuery(entityData);
        return this.resource(entity)
            .patch(query)
            .then(function (res) { return _this.processResponse(res); });
    };
    BaseRepository.prototype.load = function (params) {
        var _this = this;
        var query;
        if (this.defaultQueryParams != null) {
            query = Object.assign({}, { params: this.defaultQueryParams }, params);
        }
        else {
            query = params;
        }
        return this.resource()
            .get(query)
            .then(function (res) { return _this.processResponse(res); });
    };
    BaseRepository.prototype.loadById = function (id, params) {
        var _this = this;
        if (id == null) {
            throw new Error('BaseRepository#loadById(): id should not be null or undefined');
        }
        var query;
        if (this.defaultQueryParams != null) {
            query = Object.assign({}, { params: this.defaultQueryParams }, params);
        }
        else {
            query = params;
        }
        return this.resource(id)
            .get(query)
            .then(function (res) { return _this.processResponse(res); });
    };
    BaseRepository.prototype.massDelete = function (entities) {
        var _this = this;
        var promisesBatch = entities.map(function (entity) { return _this.delete(entity); });
        return Promise.all(promisesBatch);
    };
    BaseRepository.prototype.delete = function (entity) {
        var _this = this;
        if (this.isEntityNew(entity)) {
            throw new Error('BaseRepository#delete(): you can not update a new entity');
        }
        return this.resource(entity)
            .delete()
            .then(function (res) { return _this.processResponse(res); });
    };
    BaseRepository.prototype.search = function (params) {
        var _this = this;
        var searchParams = this.resolveSearchParams(params);
        var requestBody = Object.assign({}, searchParams, this.defaultQueryParams);
        return this.resource()
            .get(requestBody)
            .then(function (res) { return _this.processResponse(res); });
    };
    BaseRepository.prototype.isEntityNew = function (entity) {
        return entity[this.entityIdKey] == null;
    };
    BaseRepository.prototype.setDefaultQueryParams = function (params) {
        this.defaultQueryParams = params;
    };
    BaseRepository.prototype.getResource = function () {
        return this.restResource;
    };
    BaseRepository.prototype.resource = function () {
        var _a;
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        if (params.length === 1) {
            return this.restResource.child(this.resolveResourceParamLiteral(params[0]));
        }
        else if (params.length) {
            return (_a = this.restResource).child.apply(_a, params);
        }
        return this.restResource;
    };
    BaseRepository.prototype.prepareEntityForRequest = function (entity) {
        var result = entity;
        if (this.dataMapper) {
            result = this.dataMapper.decode(entity);
        }
        if (this.requestEntityWrap) {
            result = this.requestEntityWrap(entity);
        }
        return result;
    };
    BaseRepository.prototype.processResponse = function (response) {
        if (!response || typeof response !== 'object') {
            return response;
        }
        var meta;
        if (this.settings.extractResponseMeta) {
            meta = __assign({ responseStatus: response._status }, this.settings.extractResponseMeta(response));
        }
        var result;
        var data = this.settings.extractResponseData && this.settings.extractResponseData(response);
        if (data && Array.isArray(data)) {
            result = data.map(this.encodeEntity, this);
        }
        else if (response && Array.isArray(response)) {
            result = response.map(this.encodeEntity, this);
        }
        else {
            result = this.encodeEntity(response);
        }
        if (meta) {
            result['meta'] = meta;
        }
        // remove _status from origin object
        if (result._status) {
            delete result._status;
        }
        return result;
    };
    BaseRepository.prototype.setSettings = function (settings) {
        this.settings = settings;
    };
    BaseRepository.prototype.addSettings = function (settings) {
        this.settings = __assign(__assign({}, this.settings), settings);
    };
    /**
     * Private helpers methods
     */
    BaseRepository.prototype.createQuery = function (entityData) {
        if (entityData instanceof FormData) {
            return entityData;
        }
        return __assign(__assign({}, entityData), this.defaultQueryParams);
    };
    BaseRepository.prototype.resolveResourceParamLiteral = function (param) {
        if (Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* isObject */ "g"])(param)) {
            return param[this.entityIdKey];
        }
        return param;
    };
    BaseRepository.prototype.resolveSearchParams = function (params) {
        if (params) {
            var searchRequestParams = this.settings.decodeSearchParams(params);
            for (var _i = 0, _a = Object.keys(searchRequestParams); _i < _a.length; _i++) {
                var key = _a[_i];
                if (searchRequestParams[key] == null || Number.isNaN(searchRequestParams[key])) {
                    delete searchRequestParams[key];
                }
            }
            return searchRequestParams;
        }
        return {};
    };
    BaseRepository.prototype.encodeEntity = function (entityData) {
        if (this.dataMapper) {
            return this.dataMapper.encode(entityData);
        }
        return entityData;
    };
    return BaseRepository;
}());



/***/ }),
/* 12 */
/***/ (function(module, exports) {



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseRepositoryBuilder; });
var BaseRepositoryBuilder = /** @class */ (function () {
    function BaseRepositoryBuilder(Repository, dataMapper) {
        this.Repository = Repository;
        this.dataMapper = dataMapper;
    }
    BaseRepositoryBuilder.prototype.build = function (resource) {
        if (!resource) {
            throw new TypeError('BaseRepositoryBuilder#build(): Resource should be defined');
        }
        return new (this.Repository)(resource, this.dataMapper);
    };
    return BaseRepositoryBuilder;
}());



/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseRestResource; });
var BaseRestResource = /** @class */ (function () {
    function BaseRestResource(resource, resourceUrl, options) {
        this.resource = resource;
        this.resourceUrl = resourceUrl;
        this.options = options;
        this.Constructor = BaseRestResource;
    }
    BaseRestResource.prototype.create = function (body, options) {
        if (body === void 0) { body = null; }
        return this.resource.post(this.resourceUrl, body, this.createOptions(options));
    };
    BaseRestResource.prototype.update = function (body, options) {
        if (body === void 0) { body = null; }
        return this.resource.put(this.resourceUrl, body, this.createOptions(options));
    };
    BaseRestResource.prototype.patch = function (body, options) {
        if (body === void 0) { body = null; }
        return this.resource.patch(this.resourceUrl, body, this.createOptions(options));
    };
    BaseRestResource.prototype.get = function (body, options) {
        return this.resource.get(this.resourceUrl, body, this.createOptions(options));
    };
    BaseRestResource.prototype.delete = function (body, options) {
        return this.resource.delete(this.resourceUrl, body, this.createOptions(options));
    };
    BaseRestResource.prototype.child = function () {
        var routeParts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            routeParts[_i] = arguments[_i];
        }
        var baseUrl = this.resource.resolveDestination(routeParts, this.resourceUrl);
        return new this.Constructor(this.resource, baseUrl, this.options);
    };
    BaseRestResource.prototype.getRequestResource = function () {
        return this.resource;
    };
    BaseRestResource.prototype.createOptions = function (options) {
        return Object.assign({}, this.options, options);
    };
    return BaseRestResource;
}());



/***/ }),
/* 15 */
/***/ (function(module, exports) {



/***/ }),
/* 16 */
/***/ (function(module, exports) {



/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(49);
var cookies = __webpack_require__(50);
var buildURL = __webpack_require__(18);
var buildFullPath = __webpack_require__(51);
var parseHeaders = __webpack_require__(54);
var isURLSameOrigin = __webpack_require__(55);
var createError = __webpack_require__(21);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        config.transitional && config.transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(19);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 25 */
/***/ (function(module, exports) {



/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageResource; });
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var StorageResource = /** @class */ (function () {
    function StorageResource(storageKey, storage, defaultOptions) {
        if (defaultOptions === void 0) { defaultOptions = {}; }
        this.storageKey = storageKey;
        this.storage = storage;
        this.defaultOptions = defaultOptions;
    }
    StorageResource.prototype.post = function (path, body, options) {
        var _a;
        var _this = this;
        if ((options === null || options === void 0 ? void 0 : options.entityIdName) != null) {
            var id = Object(_utils_helpers__WEBPACK_IMPORTED_MODULE_0__[/* uuid */ "l"])();
            var resultPath_1 = path + "/" + id;
            var resultBody = __assign(__assign({}, body), (_a = {}, _a[options.entityIdName] = id, _a));
            return this.storage
                .setItem(resultPath_1, resultBody)
                .then(function (data) { return _this.processExtractedData(data); })
                .then(function (data) { return _this.addEntityIdPath(resultPath_1).then(function () { return data; }); });
        }
        return this.storage.setItem(path, body).then(function (data) { return _this.processExtractedData(data); });
    };
    StorageResource.prototype.put = function (path, body, options) {
        var _this = this;
        return this.storage.setItem(path, body).then(function (data) { return _this.processExtractedData(data); });
    };
    StorageResource.prototype.patch = function (path, body, options) {
        var _this = this;
        return this.get(path).then(function (savedBody) {
            if (savedBody === void 0) { savedBody = {}; }
            var newBody = __assign(__assign({}, savedBody), body);
            return _this.put(path, newBody);
        });
    };
    StorageResource.prototype.get = function (path, body, options) {
        var _this = this;
        return this.storage.getItem(path).then(function (data) { return _this.processExtractedData(data); });
    };
    StorageResource.prototype.delete = function (path, options) {
        var _this = this;
        if ((options === null || options === void 0 ? void 0 : options.entityIdName) != null) {
            return this.storage
                .removeItem(path)
                .then(function (response) { return _this.removeEntityIdPath(path).then(function () { return response; }); });
        }
        return this.storage.removeItem(path);
    };
    StorageResource.prototype.setHeaders = function (headers) {
        this.defaultOptions.headers = Object.assign({}, this.defaultOptions.headers, headers);
    };
    StorageResource.prototype.clearHeaders = function () {
        delete this.defaultOptions.headers;
    };
    StorageResource.prototype.setBasePath = function (basePath) {
        this.storageKey = basePath;
    };
    StorageResource.prototype.resolveDestination = function (pathParts, basePath) {
        return pathParts.reduce(function (resultUrl, routePart) { return resultUrl + "/" + routePart; }, basePath);
    };
    StorageResource.prototype.getAllEntities = function () {
        var _this = this;
        return this.storage
            .getItem(this.idsStorageKey)
            .then(function (pathsMap) {
            if (pathsMap === void 0) { pathsMap = {}; }
            if (pathsMap) {
                return Object.keys(pathsMap);
            }
            return [];
        })
            .then(function (paths) {
            if (paths && paths.length) {
                var promises = paths.map(function (path) { return _this.get(path); });
                return Promise.all(promises);
            }
            return [];
        });
    };
    StorageResource.prototype.processExtractedData = function (data) {
        return data;
    };
    StorageResource.prototype.addEntityIdPath = function (id) {
        var _this = this;
        return this.storage.getItem(this.idsStorageKey).then(function (idsMap) {
            idsMap = idsMap || {};
            idsMap[id] = true;
            return _this.storage.setItem(_this.idsStorageKey, idsMap);
        });
    };
    StorageResource.prototype.removeEntityIdPath = function (id) {
        var _this = this;
        return this.storage.getItem(this.idsStorageKey).then(function (idsMap) {
            idsMap = idsMap || {};
            delete idsMap[id];
            return _this.storage.setItem(_this.idsStorageKey, idsMap);
        });
    };
    Object.defineProperty(StorageResource.prototype, "idsStorageKey", {
        get: function () {
            return this.storageKey + "/entities_ids";
        },
        enumerable: false,
        configurable: true
    });
    StorageResource.prototype.getQueryString = function () {
        return 'not supported';
    };
    return StorageResource;
}());



/***/ }),
/* 27 */
/***/ (function(module, exports) {



/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _interfaces_BaseAttrMapConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29);
/* harmony import */ var _interfaces_BaseAttrMapConfig__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_interfaces_BaseAttrMapConfig__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _interfaces_BaseAttrMapConfig__WEBPACK_IMPORTED_MODULE_0__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _interfaces_BaseAttrMapConfig__WEBPACK_IMPORTED_MODULE_0__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _interfaces_BaseMappingMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30);
/* harmony import */ var _interfaces_BaseMappingMethod__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_interfaces_BaseMappingMethod__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _interfaces_BaseMappingMethod__WEBPACK_IMPORTED_MODULE_1__) if(["default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _interfaces_BaseMappingMethod__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _BaseDataMapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseDataMapper", function() { return _BaseDataMapper__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _BaseMapType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseMapType", function() { return _BaseMapType__WEBPACK_IMPORTED_MODULE_3__["a"]; });







/***/ }),
/* 29 */
/***/ (function(module, exports) {



/***/ }),
/* 30 */
/***/ (function(module, exports) {



/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseDataMapper; });
/* harmony import */ var _BaseMapType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);

var BaseDataMapper = /** @class */ (function () {
    function BaseDataMapper(mappingStrategy) {
        this.mappingStrategy = mappingStrategy;
    }
    BaseDataMapper.prototype.encode = function (a) {
        return _BaseMapType__WEBPACK_IMPORTED_MODULE_0__[/* BaseMapType */ "a"].encode(a, this.mappingStrategy);
    };
    BaseDataMapper.prototype.decode = function (a) {
        return _BaseMapType__WEBPACK_IMPORTED_MODULE_0__[/* BaseMapType */ "a"].decode(a, this.mappingStrategy);
    };
    return BaseDataMapper;
}());



/***/ }),
/* 32 */
/***/ (function(module, exports) {



/***/ }),
/* 33 */
/***/ (function(module, exports) {



/***/ }),
/* 34 */
/***/ (function(module, exports) {



/***/ }),
/* 35 */
/***/ (function(module, exports) {



/***/ }),
/* 36 */
/***/ (function(module, exports) {



/***/ }),
/* 37 */
/***/ (function(module, exports) {



/***/ }),
/* 38 */
/***/ (function(module, exports) {



/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ FetchResource_FetchResource; });

// EXTERNAL MODULE: ./src/resources/fetch/DefaultFetchResourceOptions.ts
var DefaultFetchResourceOptions = __webpack_require__(8);

// EXTERNAL MODULE: ./src/enums/ContentTypeEnum.ts
var ContentTypeEnum = __webpack_require__(2);

// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(0);

// CONCATENATED MODULE: ./src/resources/fetch/helpers.ts
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


function resolveFetchRequestBody(body, options) {
    if (options) {
        if (body != null) {
            if (options.contentType === ContentTypeEnum["a" /* ContentTypeEnum */].FORM_DATA) {
                return Object(helpers["k" /* transformToFormData */])(body);
            }
            else if (options.contentType === ContentTypeEnum["a" /* ContentTypeEnum */].JSON) {
                return JSON.stringify(body);
            }
            else if (!!options.contentType) {
                return body;
            }
        }
        else {
            return body;
        }
    }
    return JSON.stringify(body);
}
function createRequestOptions(method, options, body) {
    return {
        method: method,
        body: body !== null && body !== void 0 ? body : undefined,
        headers: Object(helpers["i" /* resolveHeaders */])(options),
        mode: options.mode,
        cache: options.cache,
        credentials: options.credentials,
        redirect: options.redirect,
        referrer: options.referrer,
    };
}
function extractResponseContent(response) {
    return __awaiter(this, void 0, void 0, function () {
        var responseContentType, responseCopy_1, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    responseContentType = response.headers.get('content-type') || '';
                    if (!(responseContentType.indexOf('application/json') > -1)) return [3 /*break*/, 1];
                    responseCopy_1 = response.clone();
                    return [2 /*return*/, response.json().catch(function (e) { return responseCopy_1.text(); })];
                case 1:
                    if (!(responseContentType.indexOf('application/octet-stream') > -1)) return [3 /*break*/, 3];
                    _a = helpers["b" /* extractBlobContent */];
                    return [4 /*yield*/, response.blob()];
                case 2: return [2 /*return*/, _a.apply(void 0, [_c.sent()])];
                case 3:
                    if (!(responseContentType.indexOf('multipart/form-data') > -1)) return [3 /*break*/, 5];
                    _b = helpers["c" /* extractFormData */];
                    return [4 /*yield*/, response.formData()];
                case 4: return [2 /*return*/, _b.apply(void 0, [_c.sent()])];
                case 5: return [2 /*return*/, response.text()];
            }
        });
    });
}

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(3);

// EXTERNAL MODULE: ./src/resources/BaseResource.ts
var BaseResource = __webpack_require__(4);

// CONCATENATED MODULE: ./src/resources/fetch/FetchResource.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var FetchResource_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var FetchResource_generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var FetchResource_FetchResource = /** @class */ (function (_super) {
    __extends(FetchResource, _super);
    function FetchResource(baseUrl, defaultOptions, _fetchClient) {
        var _this = _super.call(this, baseUrl) || this;
        _this.defaultOptions = __assign(__assign({}, DefaultFetchResourceOptions["a" /* DefaultFetchResourceOptions */]), defaultOptions);
        if (_fetchClient) {
            _this._fetchClient = _fetchClient;
        }
        else if (Object(utils["b" /* isBrowser */])() && !_fetchClient) {
            _this._fetchClient = fetch.bind(window);
        }
        return _this;
    }
    FetchResource.prototype.post = function (url, body, options) {
        return FetchResource_awaiter(this, void 0, void 0, function () {
            var _a, requestUrl, requestOptions;
            return FetchResource_generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.createRequest({
                            method: 'POST',
                            url: url,
                            options: options,
                            body: body,
                        })];
                    case 1:
                        _a = _b.sent(), requestUrl = _a.requestUrl, requestOptions = _a.requestOptions;
                        return [2 /*return*/, this.fetchHandleCode(requestUrl, requestOptions)];
                }
            });
        });
    };
    FetchResource.prototype.put = function (url, body, options) {
        return FetchResource_awaiter(this, void 0, void 0, function () {
            var _a, requestUrl, requestOptions;
            return FetchResource_generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.createRequest({
                            method: 'PUT',
                            url: url,
                            options: options,
                            body: body,
                        })];
                    case 1:
                        _a = _b.sent(), requestUrl = _a.requestUrl, requestOptions = _a.requestOptions;
                        return [2 /*return*/, this.fetchHandleCode(requestUrl, requestOptions)];
                }
            });
        });
    };
    FetchResource.prototype.patch = function (url, body, options) {
        return FetchResource_awaiter(this, void 0, void 0, function () {
            var _a, requestUrl, requestOptions;
            return FetchResource_generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.createRequest({
                            method: 'PATCH',
                            url: url,
                            options: options,
                            body: body,
                        })];
                    case 1:
                        _a = _b.sent(), requestUrl = _a.requestUrl, requestOptions = _a.requestOptions;
                        return [2 /*return*/, this.fetchHandleCode(requestUrl, requestOptions)];
                }
            });
        });
    };
    FetchResource.prototype.get = function (url, queryParams, options) {
        return FetchResource_awaiter(this, void 0, void 0, function () {
            var _a, requestUrl, requestOptions;
            return FetchResource_generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.createRequest({
                            method: 'GET',
                            url: url,
                            options: __assign(__assign({}, options), { queryParams: queryParams }),
                        })];
                    case 1:
                        _a = _b.sent(), requestUrl = _a.requestUrl, requestOptions = _a.requestOptions;
                        return [2 /*return*/, this.fetchHandleCode(requestUrl, requestOptions)];
                }
            });
        });
    };
    FetchResource.prototype.delete = function (url, body, options) {
        return FetchResource_awaiter(this, void 0, void 0, function () {
            var _a, requestUrl, requestOptions;
            return FetchResource_generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.createRequest({
                            method: 'DELETE',
                            url: url,
                            options: options,
                            body: body,
                        })];
                    case 1:
                        _a = _b.sent(), requestUrl = _a.requestUrl, requestOptions = _a.requestOptions;
                        return [2 /*return*/, this.fetchHandleCode(requestUrl, requestOptions)];
                }
            });
        });
    };
    FetchResource.prototype.setHeaders = function (headers) {
        this.defaultOptions.headers = Object.assign({}, this.defaultOptions.headers, headers);
    };
    FetchResource.prototype.clearHeaders = function () {
        delete this.defaultOptions.headers;
    };
    FetchResource.prototype.setBasePath = function (baseUrl) {
        this.setUrlSource(baseUrl);
    };
    FetchResource.prototype.resolveDestination = function (pathParts, basePath) {
        return pathParts.reduce(function (resultUrl, routePart) { return resultUrl + "/" + routePart; }, basePath).replace(/([^:]\/)\/+/g, '$1');
    };
    FetchResource.prototype.getAllEntities = function () {
        return new Promise(function (_, reject) {
            reject(new Error('BaseHttpResource #getAllEntities(): need to provide method'));
        });
    };
    FetchResource.prototype.fetchHandleCode = function (url, options) {
        var _this = this;
        return new Promise(function (resolve, reject) { return FetchResource_awaiter(_this, void 0, void 0, function () {
            var _a, error, can;
            var _this = this;
            return FetchResource_generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.defaultOptions.canSendRequest !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.defaultOptions.canSendRequest()];
                    case 1:
                        _a = _b.sent(), error = _a.error, can = _a.can;
                        if (!can) {
                            throw error;
                        }
                        _b.label = 2;
                    case 2:
                        this.fetchClient(url, options)
                            .then(function (response) { return FetchResource_awaiter(_this, void 0, void 0, function () {
                            var data;
                            var _a;
                            return FetchResource_generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, extractResponseContent(response.clone())];
                                    case 1:
                                        data = _b.sent();
                                        if (typeof data === 'object') {
                                            Object.assign(data, (_a = {}, _a['_status'] = response.status, _a));
                                        }
                                        if (response.ok) {
                                            resolve(data);
                                        }
                                        else {
                                            this.notifyErrorHandlers({ response: response, parsedBody: data });
                                            reject(data);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); })
                            .catch(function (error) { return FetchResource_awaiter(_this, void 0, void 0, function () {
                            return FetchResource_generator(this, function (_a) {
                                return [2 /*return*/, reject(error)];
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    FetchResource.prototype.createRequest = function (data) {
        return FetchResource_awaiter(this, void 0, void 0, function () {
            var method, url, options, body, mergedOptions, requestUrl, decodedBody, requestOptions, query;
            return FetchResource_generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        method = data.method, url = data.url, options = data.options, body = data.body;
                        mergedOptions = this.resolveRequestOptions(options);
                        return [4 /*yield*/, this.resolveRequestUrl(url, mergedOptions)];
                    case 1:
                        requestUrl = _a.sent();
                        decodedBody = resolveFetchRequestBody(body, options);
                        requestOptions = createRequestOptions(method, mergedOptions, decodedBody);
                        query = this.getQueryString(options === null || options === void 0 ? void 0 : options.queryParams, options);
                        requestUrl = [requestUrl, query].filter(Boolean).join('?');
                        return [2 /*return*/, { requestUrl: requestUrl, requestOptions: requestOptions }];
                }
            });
        });
    };
    FetchResource.prototype.resolveRequestUrl = function (url, o) {
        return FetchResource_awaiter(this, void 0, void 0, function () {
            var baseUrl, urlPart;
            return FetchResource_generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBaseUrl()];
                    case 1:
                        baseUrl = _a.sent();
                        urlPart = "/" + url + ((o === null || o === void 0 ? void 0 : o.trailingSlash) ? '/' : '');
                        return [2 /*return*/, (baseUrl + urlPart).replace(/([^:]\/)\/+/g, '$1')];
                }
            });
        });
    };
    FetchResource.prototype.resolveRequestOptions = function (options) {
        return __assign(__assign({}, this.defaultOptions), options);
    };
    FetchResource.prototype.getQueryString = function (params, options) {
        if (params === void 0) { params = {}; }
        var _a = __assign(__assign({}, this.defaultOptions), options), timeOffset = _a.timeOffset, queryParamsDecodeMode = _a.queryParamsDecodeMode;
        if (timeOffset) {
            params['timeoffset'] = new Date().getTimezoneOffset() * -1;
        }
        return Object(utils["a" /* decodeQueryString */])(params, queryParamsDecodeMode);
    };
    Object.defineProperty(FetchResource.prototype, "fetchClient", {
        get: function () {
            return this._fetchClient || fetch;
        },
        enumerable: false,
        configurable: true
    });
    return FetchResource;
}(BaseResource["a" /* BaseResource */]));



/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ AxiosResource_AxiosResource; });

// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(0);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(5);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/resources/axios/DefaultAxiosResourceOptions.ts
var DefaultAxiosResourceOptions = __webpack_require__(9);

// EXTERNAL MODULE: ./src/enums/ContentTypeEnum.ts
var ContentTypeEnum = __webpack_require__(2);

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(3);

// CONCATENATED MODULE: ./src/resources/axios/helpers.ts


function resolveAxiosRequestBody(body, options) {
    if (options && body != null && options.contentType === ContentTypeEnum["a" /* ContentTypeEnum */].FORM_DATA) {
        return Object(utils["d" /* transformToFormData */])(body);
    }
    return body;
}

// EXTERNAL MODULE: ./src/resources/BaseResource.ts
var BaseResource = __webpack_require__(4);

// CONCATENATED MODULE: ./src/resources/axios/AxiosResource.ts
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var AxiosResource_AxiosResource = /** @class */ (function (_super) {
    __extends(AxiosResource, _super);
    function AxiosResource(baseUrl, defaultOptions) {
        if (defaultOptions === void 0) { defaultOptions = DefaultAxiosResourceOptions["a" /* DefaultAxiosResourceOptions */]; }
        var _this = _super.call(this, baseUrl) || this;
        _this.defaultOptions = defaultOptions;
        return _this;
    }
    AxiosResource.prototype.post = function (path, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var resolverSettings, _a, targetUrl, requestOptions, decodedBody;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        resolverSettings = { path: path, options: options, body: body, useBodyAsQueryParams: false };
                        return [4 /*yield*/, this.resolveRequestParams(resolverSettings)];
                    case 1:
                        _a = _b.sent(), targetUrl = _a.targetUrl, requestOptions = _a.requestOptions;
                        decodedBody = resolveAxiosRequestBody(body, options);
                        return [2 /*return*/, this.decorateRequest(axios_default.a.post(targetUrl, decodedBody, requestOptions))];
                }
            });
        });
    };
    AxiosResource.prototype.put = function (path, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var resolverSettings, _a, targetUrl, requestOptions, decodedBody;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        resolverSettings = { path: path, options: options, body: body, useBodyAsQueryParams: false };
                        return [4 /*yield*/, this.resolveRequestParams(resolverSettings)];
                    case 1:
                        _a = _b.sent(), targetUrl = _a.targetUrl, requestOptions = _a.requestOptions;
                        decodedBody = resolveAxiosRequestBody(body, options);
                        return [2 /*return*/, this.decorateRequest(axios_default.a.put(targetUrl, decodedBody, requestOptions))];
                }
            });
        });
    };
    AxiosResource.prototype.patch = function (path, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var resolverSettings, _a, targetUrl, requestOptions, decodedBody;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        resolverSettings = { path: path, options: options, body: body, useBodyAsQueryParams: false };
                        return [4 /*yield*/, this.resolveRequestParams(resolverSettings)];
                    case 1:
                        _a = _b.sent(), targetUrl = _a.targetUrl, requestOptions = _a.requestOptions;
                        decodedBody = resolveAxiosRequestBody(body, options);
                        return [2 /*return*/, this.decorateRequest(axios_default.a.patch(targetUrl, decodedBody, requestOptions))];
                }
            });
        });
    };
    AxiosResource.prototype.get = function (path, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var resolverSettings, _a, targetUrl, requestOptions;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        resolverSettings = { path: path, options: options, body: body, useBodyAsQueryParams: true };
                        return [4 /*yield*/, this.resolveRequestParams(resolverSettings)];
                    case 1:
                        _a = _b.sent(), targetUrl = _a.targetUrl, requestOptions = _a.requestOptions;
                        return [2 /*return*/, this.decorateRequest(axios_default.a.get(targetUrl, requestOptions))];
                }
            });
        });
    };
    AxiosResource.prototype.delete = function (path, body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var resolverSettings, _a, targetUrl, requestOptions;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        resolverSettings = { path: path, options: options, body: body, useBodyAsQueryParams: true };
                        return [4 /*yield*/, this.resolveRequestParams(resolverSettings)];
                    case 1:
                        _a = _b.sent(), targetUrl = _a.targetUrl, requestOptions = _a.requestOptions;
                        return [2 /*return*/, this.decorateRequest(axios_default.a.delete(targetUrl, requestOptions))];
                }
            });
        });
    };
    AxiosResource.prototype.setHeaders = function (headers) {
        this.defaultOptions.headers = __assign(__assign({}, this.defaultOptions.headers), headers);
    };
    AxiosResource.prototype.clearHeaders = function () {
        delete this.defaultOptions.headers;
    };
    AxiosResource.prototype.setBasePath = function (urlSource) {
        this.setUrlSource(urlSource);
    };
    AxiosResource.prototype.resolveDestination = function (pathParts, basePath) {
        return pathParts.reduce(function (resultUrl, routePart) { return resultUrl + "/" + routePart; }, basePath).replace(/([^:]\/)\/+/g, '$1');
    };
    AxiosResource.prototype.getAllEntities = function () {
        return new Promise(function (_, reject) {
            reject(new Error('AxiosResource#getAllEntities(): need to provide method'));
        });
    };
    AxiosResource.prototype.getQueryString = function (params, options) {
        if (params === void 0) { params = {}; }
        var queryParamsDecodeMode = __assign(__assign({}, this.defaultOptions), options).queryParamsDecodeMode;
        return Object(helpers["a" /* decodeQueryString */])(params, queryParamsDecodeMode);
    };
    AxiosResource.prototype.handleResponse = function (response) {
        var _a;
        var data = response.data;
        if (typeof data === 'object') {
            return Object.assign(data, (_a = {}, _a['_status'] = response.status, _a));
        }
        return data;
    };
    AxiosResource.prototype.decorateRequest = function (request) {
        var _this = this;
        return request
            .then(function (res) { return _this.handleResponse(res); })
            .catch(function (error) {
            var _a;
            _this.notifyErrorHandlers({ response: error, parsedBody: error.response });
            throw { _status: ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) || (error === null || error === void 0 ? void 0 : error.code), data: error };
        });
    };
    AxiosResource.prototype.resolveRequestParams = function (settings) {
        return __awaiter(this, void 0, void 0, function () {
            var path, options, useBodyAsQueryParams, body, resourceConfig, requestOptions, params, targetUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = settings.path, options = settings.options, useBodyAsQueryParams = settings.useBodyAsQueryParams, body = settings.body;
                        resourceConfig = __assign(__assign({}, this.defaultOptions), options);
                        requestOptions = this.getRequestOptions(resourceConfig);
                        if (useBodyAsQueryParams) {
                            params = __assign(__assign({}, (options === null || options === void 0 ? void 0 : options.params) || {}), (body || {}));
                            requestOptions = __assign(__assign({}, requestOptions), { params: params });
                        }
                        // add timeoffset
                        if (resourceConfig === null || resourceConfig === void 0 ? void 0 : resourceConfig.timeOffset) {
                            if (!(requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.params)) {
                                requestOptions.params = {};
                            }
                            requestOptions.params['timeoffset'] = new Date().getTimezoneOffset() * -1;
                        }
                        // add params serializer
                        if (!(resourceConfig === null || resourceConfig === void 0 ? void 0 : resourceConfig.paramsSerializer)) {
                            requestOptions.paramsSerializer = function (params) {
                                return Object(helpers["a" /* decodeQueryString */])(params, resourceConfig.queryParamsDecodeMode);
                            };
                        }
                        // if form data, use headers
                        requestOptions.headers = Object(helpers["i" /* resolveHeaders */])(requestOptions);
                        return [4 /*yield*/, this.resolveRequestUrl(path, resourceConfig)];
                    case 1:
                        targetUrl = _a.sent();
                        return [2 /*return*/, { targetUrl: targetUrl, requestOptions: requestOptions }];
                }
            });
        });
    };
    AxiosResource.prototype.getRequestOptions = function (options) {
        var trailingSlash = options.trailingSlash, queryParamsDecodeMode = options.queryParamsDecodeMode, timeOffset = options.timeOffset, other = __rest(options, ["trailingSlash", "queryParamsDecodeMode", "timeOffset"]);
        return other;
    };
    AxiosResource.prototype.resolveRequestUrl = function (url, o) {
        return __awaiter(this, void 0, void 0, function () {
            var baseUrl, urlPart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBaseUrl()];
                    case 1:
                        baseUrl = _a.sent();
                        urlPart = "/" + url + ((o === null || o === void 0 ? void 0 : o.trailingSlash) ? '/' : '');
                        return [2 /*return*/, (baseUrl + urlPart).replace(/([^:]\/)\/+/g, '$1')];
                }
            });
        });
    };
    return AxiosResource;
}(BaseResource["a" /* BaseResource */]));



/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _repository_BaseRepository__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseRepository", function() { return _repository_BaseRepository__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _repository_RepositorySettings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12);
/* harmony import */ var _repository_RepositorySettings__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_repository_RepositorySettings__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _repository_RepositorySettings__WEBPACK_IMPORTED_MODULE_1__) if(["default","BaseRepository"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _repository_RepositorySettings__WEBPACK_IMPORTED_MODULE_1__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _repository_DefaultRepositorySettings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultRepositorySettings", function() { return _repository_DefaultRepositorySettings__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _BaseRepositoryBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseRepositoryBuilder", function() { return _BaseRepositoryBuilder__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _BaseRestResource__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseRestResource", function() { return _BaseRestResource__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _resources_BaseResource__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseResource", function() { return _resources_BaseResource__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _resources_fetch_FetchResource__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FetchResource", function() { return _resources_fetch_FetchResource__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony import */ var _resources_fetch_FetchResourceOptions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15);
/* harmony import */ var _resources_fetch_FetchResourceOptions__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_resources_fetch_FetchResourceOptions__WEBPACK_IMPORTED_MODULE_7__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _resources_fetch_FetchResourceOptions__WEBPACK_IMPORTED_MODULE_7__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _resources_fetch_FetchResourceOptions__WEBPACK_IMPORTED_MODULE_7__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _resources_fetch_DefaultFetchResourceOptions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultFetchResourceOptions", function() { return _resources_fetch_DefaultFetchResourceOptions__WEBPACK_IMPORTED_MODULE_8__["a"]; });

/* harmony import */ var _resources_fetch_FetchRequestMethod__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16);
/* harmony import */ var _resources_fetch_FetchRequestMethod__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_resources_fetch_FetchRequestMethod__WEBPACK_IMPORTED_MODULE_9__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _resources_fetch_FetchRequestMethod__WEBPACK_IMPORTED_MODULE_9__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _resources_fetch_FetchRequestMethod__WEBPACK_IMPORTED_MODULE_9__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _resources_axios_DefaultAxiosResourceOptions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultAxiosResourceOptions", function() { return _resources_axios_DefaultAxiosResourceOptions__WEBPACK_IMPORTED_MODULE_10__["a"]; });

/* harmony import */ var _resources_axios_AxiosResource__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AxiosResource", function() { return _resources_axios_AxiosResource__WEBPACK_IMPORTED_MODULE_11__["a"]; });

/* harmony import */ var _resources_axios_AxiosResourceOptions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25);
/* harmony import */ var _resources_axios_AxiosResourceOptions__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_resources_axios_AxiosResourceOptions__WEBPACK_IMPORTED_MODULE_12__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _resources_axios_AxiosResourceOptions__WEBPACK_IMPORTED_MODULE_12__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _resources_axios_AxiosResourceOptions__WEBPACK_IMPORTED_MODULE_12__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _resources_storage_StorageResource__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StorageResource", function() { return _resources_storage_StorageResource__WEBPACK_IMPORTED_MODULE_13__["a"]; });

/* harmony import */ var _resources_storage_StorageResourceOptions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(27);
/* harmony import */ var _resources_storage_StorageResourceOptions__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_resources_storage_StorageResourceOptions__WEBPACK_IMPORTED_MODULE_14__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _resources_storage_StorageResourceOptions__WEBPACK_IMPORTED_MODULE_14__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource","StorageResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _resources_storage_StorageResourceOptions__WEBPACK_IMPORTED_MODULE_14__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _data_mapper_index__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(28);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _data_mapper_index__WEBPACK_IMPORTED_MODULE_15__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource","StorageResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _data_mapper_index__WEBPACK_IMPORTED_MODULE_15__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _interfaces_IBaseResource__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(32);
/* harmony import */ var _interfaces_IBaseResource__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_interfaces_IBaseResource__WEBPACK_IMPORTED_MODULE_16__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _interfaces_IBaseResource__WEBPACK_IMPORTED_MODULE_16__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource","StorageResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _interfaces_IBaseResource__WEBPACK_IMPORTED_MODULE_16__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _interfaces_Storage__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(33);
/* harmony import */ var _interfaces_Storage__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_interfaces_Storage__WEBPACK_IMPORTED_MODULE_17__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _interfaces_Storage__WEBPACK_IMPORTED_MODULE_17__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource","StorageResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _interfaces_Storage__WEBPACK_IMPORTED_MODULE_17__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _interfaces_ArrayMeta__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(34);
/* harmony import */ var _interfaces_ArrayMeta__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_interfaces_ArrayMeta__WEBPACK_IMPORTED_MODULE_18__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _interfaces_ArrayMeta__WEBPACK_IMPORTED_MODULE_18__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource","StorageResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _interfaces_ArrayMeta__WEBPACK_IMPORTED_MODULE_18__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _types_BaseEntity__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(35);
/* harmony import */ var _types_BaseEntity__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_types_BaseEntity__WEBPACK_IMPORTED_MODULE_19__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _types_BaseEntity__WEBPACK_IMPORTED_MODULE_19__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource","StorageResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _types_BaseEntity__WEBPACK_IMPORTED_MODULE_19__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _interfaces_BaseMeta__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(36);
/* harmony import */ var _interfaces_BaseMeta__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_interfaces_BaseMeta__WEBPACK_IMPORTED_MODULE_20__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _interfaces_BaseMeta__WEBPACK_IMPORTED_MODULE_20__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource","StorageResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _interfaces_BaseMeta__WEBPACK_IMPORTED_MODULE_20__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _interfaces_EntityMeta__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(37);
/* harmony import */ var _interfaces_EntityMeta__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_interfaces_EntityMeta__WEBPACK_IMPORTED_MODULE_21__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _interfaces_EntityMeta__WEBPACK_IMPORTED_MODULE_21__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource","StorageResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _interfaces_EntityMeta__WEBPACK_IMPORTED_MODULE_21__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _types_ResourceResponse__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(38);
/* harmony import */ var _types_ResourceResponse__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_types_ResourceResponse__WEBPACK_IMPORTED_MODULE_22__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in _types_ResourceResponse__WEBPACK_IMPORTED_MODULE_22__) if(["default","BaseRepository","DefaultRepositorySettings","BaseRepositoryBuilder","BaseRestResource","BaseResource","FetchResource","DefaultFetchResourceOptions","DefaultAxiosResourceOptions","AxiosResource","StorageResource"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return _types_ResourceResponse__WEBPACK_IMPORTED_MODULE_22__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var _enums_ContentTypeEnum__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(2);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ContentTypeEnum", function() { return _enums_ContentTypeEnum__WEBPACK_IMPORTED_MODULE_23__["a"]; });



























/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(17);
var Axios = __webpack_require__(43);
var mergeConfig = __webpack_require__(23);
var defaults = __webpack_require__(10);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(24);
axios.CancelToken = __webpack_require__(58);
axios.isCancel = __webpack_require__(22);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(59);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(60);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(18);
var InterceptorManager = __webpack_require__(44);
var dispatchRequest = __webpack_require__(45);
var mergeConfig = __webpack_require__(23);
var validator = __webpack_require__(56);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      forcedJSONParsing: validators.transitional(validators.boolean, '1.0.0'),
      clarifyTimeoutError: validators.transitional(validators.boolean, '1.0.0')
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(46);
var isCancel = __webpack_require__(22);
var defaults = __webpack_require__(10);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var defaults = __webpack_require__(10);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(21);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(52);
var combineURLs = __webpack_require__(53);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pkg = __webpack_require__(57);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};
var currentVerArr = pkg.version.split('.');

/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */
function isOlderVersion(version, thanVersion) {
  var pkgVersionArr = thanVersion ? thanVersion.split('.') : currentVerArr;
  var destVer = version.split('.');
  for (var i = 0; i < 3; i++) {
    if (pkgVersionArr[i] > destVer[i]) {
      return true;
    } else if (pkgVersionArr[i] < destVer[i]) {
      return false;
    }
  }
  return false;
}

/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  var isDeprecated = version && isOlderVersion(version);

  function formatMessage(opt, desc) {
    return '[Axios v' + pkg.version + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed in ' + version));
    }

    if (isDeprecated && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  isOlderVersion: isOlderVersion,
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 57 */
/***/ (function(module) {

module.exports = JSON.parse("{\"_from\":\"axios@^0.21.x\",\"_id\":\"axios@0.21.4\",\"_inBundle\":false,\"_integrity\":\"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==\",\"_location\":\"/axios\",\"_phantomChildren\":{},\"_requested\":{\"type\":\"range\",\"registry\":true,\"raw\":\"axios@^0.21.x\",\"name\":\"axios\",\"escapedName\":\"axios\",\"rawSpec\":\"^0.21.x\",\"saveSpec\":null,\"fetchSpec\":\"^0.21.x\"},\"_requiredBy\":[\"#DEV:/\"],\"_resolved\":\"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz\",\"_shasum\":\"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575\",\"_spec\":\"axios@^0.21.x\",\"_where\":\"/Users/alexeyryabov/git/domain-js\",\"author\":{\"name\":\"Matt Zabriskie\"},\"browser\":{\"./lib/adapters/http.js\":\"./lib/adapters/xhr.js\"},\"bugs\":{\"url\":\"https://github.com/axios/axios/issues\"},\"bundleDependencies\":false,\"bundlesize\":[{\"path\":\"./dist/axios.min.js\",\"threshold\":\"5kB\"}],\"dependencies\":{\"follow-redirects\":\"^1.14.0\"},\"deprecated\":false,\"description\":\"Promise based HTTP client for the browser and node.js\",\"devDependencies\":{\"coveralls\":\"^3.0.0\",\"es6-promise\":\"^4.2.4\",\"grunt\":\"^1.3.0\",\"grunt-banner\":\"^0.6.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-clean\":\"^1.1.0\",\"grunt-contrib-watch\":\"^1.0.0\",\"grunt-eslint\":\"^23.0.0\",\"grunt-karma\":\"^4.0.0\",\"grunt-mocha-test\":\"^0.13.3\",\"grunt-ts\":\"^6.0.0-beta.19\",\"grunt-webpack\":\"^4.0.2\",\"istanbul-instrumenter-loader\":\"^1.0.0\",\"jasmine-core\":\"^2.4.1\",\"karma\":\"^6.3.2\",\"karma-chrome-launcher\":\"^3.1.0\",\"karma-firefox-launcher\":\"^2.1.0\",\"karma-jasmine\":\"^1.1.1\",\"karma-jasmine-ajax\":\"^0.1.13\",\"karma-safari-launcher\":\"^1.0.0\",\"karma-sauce-launcher\":\"^4.3.6\",\"karma-sinon\":\"^1.0.5\",\"karma-sourcemap-loader\":\"^0.3.8\",\"karma-webpack\":\"^4.0.2\",\"load-grunt-tasks\":\"^3.5.2\",\"minimist\":\"^1.2.0\",\"mocha\":\"^8.2.1\",\"sinon\":\"^4.5.0\",\"terser-webpack-plugin\":\"^4.2.3\",\"typescript\":\"^4.0.5\",\"url-search-params\":\"^0.10.0\",\"webpack\":\"^4.44.2\",\"webpack-dev-server\":\"^3.11.0\"},\"homepage\":\"https://axios-http.com\",\"jsdelivr\":\"dist/axios.min.js\",\"keywords\":[\"xhr\",\"http\",\"ajax\",\"promise\",\"node\"],\"license\":\"MIT\",\"main\":\"index.js\",\"name\":\"axios\",\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/axios/axios.git\"},\"scripts\":{\"build\":\"NODE_ENV=production grunt build\",\"coveralls\":\"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js\",\"examples\":\"node ./examples/server.js\",\"fix\":\"eslint --fix lib/**/*.js\",\"postversion\":\"git push && git push --tags\",\"preversion\":\"npm test\",\"start\":\"node ./sandbox/server.js\",\"test\":\"grunt test\",\"version\":\"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json\"},\"typings\":\"./index.d.ts\",\"unpkg\":\"dist/axios.min.js\",\"version\":\"0.21.4\"}");

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(24);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ })
/******/ ]);